import './sentry.ts';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { ErrorView } from './components/ErrorView';
import { StrictMode } from 'react';
import {
  basicLogger,
  ProviderConfig,
  withLDProvider,
} from 'launchdarkly-react-client-sdk';
import { ConfigService } from '@axo/config';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById('root')!;
const root = createRoot(container);

ConfigService.bootstrap(['env']);

const ldConfig: ProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
  reactOptions: { useCamelCaseFlagKeys: false },
  context: {
    key: 'ace',
    kind: 'ace',
  },
  options: {
    logger: basicLogger({
      level: import.meta.env.DEV ? 'info' : 'warn',
    }),
  },
};

const AppRoot = withLDProvider(ldConfig)(() => {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <ErrorView
          title="Something went wrong"
          description={
            'Something has gone wrong and ACE has crashed. Please reload, and contact your manager if the problem persists.'
          }
        />
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  );
});

root.render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
